// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scene_message {\n  max-width: 400px;\n}\n.scene_message .el-cascader-panel .el-scrollbar:first-child .el-checkbox {\n  pointer-events: none;\n}", ""]);
// Exports
module.exports = exports;
